module.exports = __webpack_public_path__ + "static/img/5.53264df2.png";